import * as semrush from '@anm/helpers/semrush';
import React, { FC } from 'react';

import routes from '../../../../routes';
import LogoutButton from '../../../auth/LogoutButton';

import { DropdownContentItem, DropdownContentWrapper, LogoutButtonWrapper } from './Wrapper';

const { Link } = routes;

export type ListContentProps = {
  list: ListItem[];
};

export type ListItem = {
  title: string;
  href: string;
};

const DropdownContent: FC<ListContentProps> = ({ list }) => {
  const isSemrush = semrush.isSemrushIframe();

  return (
    <DropdownContentWrapper>
      {list.map(({ href, title }) => (
        <li key={title}>
          <DropdownContentItem>
            <Link route={href}>{title}</Link>
          </DropdownContentItem>
        </li>
      ))}
      {!isSemrush && (
        <LogoutButtonWrapper>
          <LogoutButton />
        </LogoutButtonWrapper>
      )}
    </DropdownContentWrapper>
  );
};

export default DropdownContent;
